import PropTypes from 'prop-types';
import React from 'react';

import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { translate } from 'helpers/translateHelper';

const UnSavedChangesModal = ({ showModal, setShowModal, handleDiscardAndContinue, isResetToDefault }) => {
    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <GeneralDialog
            show={showModal}
            close={() => handleCloseModal()}
            notificationType='warning'
            title={translate('ABB.Powertrain.Frontend.unsavedChangesWarningPopupTitle')}
            cancelButtonProps={!isResetToDefault && {
                text: translate('ABB.Powertrain.Frontend.limitDiscardButtonTitle'),
                onClick: handleDiscardAndContinue
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.limitButtonGoBack'),
                onClick: () => handleCloseModal()
            }}
            dialogClassName='unsaved-changes-modal'
            closeButton={true}
            persistent={false}
        >
            <div>
                {isResetToDefault ? translate('ABB.Powertrain.Frontend.limitsUnSavedChangesResetToDefault') :
                    translate('ABB.Powertrain.Frontend.unsavedLimitsPromtMessage')}
            </div>
        </GeneralDialog>
    );
};

UnSavedChangesModal.propTypes = {
    showModal: PropTypes.bool,
    isResetToDefault: PropTypes.bool,
    setShowModal: PropTypes.func,
    handleDiscardAndContinue: PropTypes.func,
};

export default React.memo(UnSavedChangesModal);
